import { render, staticRenderFns } from "./AffirmationCategoryAddModal.vue?vue&type=template&id=2e040a7c"
import script from "./AffirmationCategoryAddModal.vue?vue&type=script&lang=js"
export * from "./AffirmationCategoryAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports